(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-swiper-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initOne = (swiperEl) => {
      if (!swiperEl) return;
      if (swiperEl.dataset.initialized === 'true') return;
      if (typeof window.Swiper === 'undefined') return;

      const sectionRoot = swiperEl.closest('section, .section, [id^="HeroSwiperBanner-"]') || document;
      const loop = swiperEl.dataset.loop === 'true';
      const speed = Number(swiperEl.dataset.speed || 500);
      const autoplay =
        swiperEl.dataset.autoplay === 'true'
          ? {
              delay: Number(swiperEl.dataset.autoplayDelay || 5000),
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false;

      // eslint-disable-next-line no-new
      new window.Swiper(swiperEl, {
        loop,
        speed,
        threshold: 8,
        resistanceRatio: 0.85,
        grabCursor: true,
        slidesPerView: 1,
        watchOverflow: true,
        pagination: {
          el: sectionRoot.querySelector('.hero-swiper-banner__pagination'),
          clickable: true,
        },
        a11y: {
          enabled: true,
        },
        autoplay,
      });

      swiperEl.dataset.initialized = 'true';
    };

    const initAll = (root = document) => {
      root.querySelectorAll('.js-hero-swiper').forEach(initOne);
    };

    const retryInitAll = (root, maxTries = 40) => {
      let tries = 0;
      const timer = window.setInterval(() => {
        tries += 1;
        if (typeof window.Swiper !== 'undefined') {
          initAll(root);
          window.clearInterval(timer);
        }
        if (tries >= maxTries) window.clearInterval(timer);
      }, 50);
    };

    const onReady = () => {
      initAll(document);
      if (typeof window.Swiper === 'undefined') retryInitAll(document);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady);
    } else {
      onReady();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
      if (typeof window.Swiper === 'undefined') retryInitAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
  class MainListCollectionsHoverSlideshow {
    constructor(container) {
      this.container = container;
      this.link = container.closest('.main-list-collections__link');
      this.sectionElement = this.getHintSection();
      this.dataNode = container.querySelector('.main-list-collections__hover-images');
      if (!this.dataNode) return;

      try {
        this.images = JSON.parse(this.dataNode.textContent);
      } catch (error) {
        this.images = [];
      }

      if (!Array.isArray(this.images) || this.images.length === 0) return;

      this.displayDuration = parseInt(container.dataset.displayDuration || '1800', 10);
      this.transitionDuration = parseInt(container.dataset.transitionDuration || '450', 10);
      this.currentIndex = 0;
      this.mobileFrameIndex = 0;
      this.intervalId = null;
      this.hasInitializedHoverLayers = false;
      this.isTransitioning = false;
      this.isHintRunning = false;
      this.hintTimerIds = [];
      this.suppressClick = false;
      this.suppressClickTimerId = null;
      this.swipePointerId = null;
      this.swipeStartX = 0;
      this.swipeStartY = 0;
      this.hasSwipeTriggered = false;
      this.swipeThreshold = 28;
      this.hasSwipeHint = container.dataset.swipeHint === 'true';
      this.preloadPromises = new Map();
      this.hintStartDelay = 700;
      this.hintAnimationDuration = 1200;

      this.hoverImageLayerA = this.createHoverLayer('main-list-collections__image--secondary');
      this.hoverImageLayerB = this.createHoverLayer('main-list-collections__image--tertiary');
      this.hintLayer = this.createHoverLayer('main-list-collections__image--hint');
      this.activeLayer = this.hoverImageLayerA;
      this.inactiveLayer = this.hoverImageLayerB;

      if (this.hasSwipeHint) {
        this.createTouchHintIndicators();
      }

      this.handlePointerEnter = this.handlePointerEnter.bind(this);
      this.handlePointerLeave = this.handlePointerLeave.bind(this);
      this.handlePointerDown = this.handlePointerDown.bind(this);
      this.handlePointerMove = this.handlePointerMove.bind(this);
      this.handlePointerUp = this.handlePointerUp.bind(this);
      this.handleLinkClick = this.handleLinkClick.bind(this);

      this.container.addEventListener('pointerenter', this.handlePointerEnter);
      this.container.addEventListener('pointerleave', this.handlePointerLeave);
      this.container.addEventListener('pointerdown', this.handlePointerDown);
      this.container.addEventListener('pointermove', this.handlePointerMove);
      this.container.addEventListener('pointerup', this.handlePointerUp);
      this.container.addEventListener('pointercancel', this.handlePointerUp);

      if (this.link) {
        this.link.addEventListener('click', this.handleLinkClick);
      }

      if (this.hasSwipeHint && this.shouldPlayHint() && !this.hasPlayedSectionHint()) {
        this.scheduleSwipeHint();
      }
    }

    shouldPlayHint() {
      if (!this.isTouchLayout()) return false;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;

      return true;
    }

    isTouchLayout() {
      return window.matchMedia('(hover: none)').matches;
    }

    getHintSection() {
      return this.container.closest('[id^="shopify-section-"]')
        || this.container.closest('.shopify-section')
        || this.container.closest('section')
        || this.container.closest('main')
        || document.body;
    }

    getHintSectionKey() {
      const sectionId = this.sectionElement?.id || this.sectionElement?.dataset?.sectionId || 'section';
      return `collection-swipe-hint:${window.location.pathname}:${sectionId}`;
    }

    hasPlayedSectionHint() {
      const key = this.getHintSectionKey();

      try {
        return window.sessionStorage.getItem(key) === 'done';
      } catch (error) {
        return this.sectionElement?.dataset?.collectionSwipeHintPlayed === 'done';
      }
    }

    markSectionHintPlayed() {
      const key = this.getHintSectionKey();

      try {
        window.sessionStorage.setItem(key, 'done');
      } catch (error) {
        if (this.sectionElement) {
          this.sectionElement.dataset.collectionSwipeHintPlayed = 'done';
        }
      }
    }

    scheduleSwipeHint() {
      this.markSectionHintPlayed();

      const startTimerId = window.setTimeout(() => {
        void this.playSwipeHint();
      }, this.hintStartDelay);

      this.hintTimerIds.push(startTimerId);
    }

    clearHintTimers() {
      this.hintTimerIds.forEach((timerId) => window.clearTimeout(timerId));
      this.hintTimerIds = [];
    }

    queueHintTimer(callback, delay) {
      const timerId = window.setTimeout(() => {
        this.hintTimerIds = this.hintTimerIds.filter((registeredTimerId) => registeredTimerId !== timerId);
        callback();
      }, delay);

      this.hintTimerIds.push(timerId);
      return timerId;
    }

    cancelSwipeHint() {
      if (!this.isHintRunning) {
        this.clearHintTimers();
        return;
      }

      this.resetHintLayer();
    }

    getPrimaryImageSourceCandidates() {
      const primaryImage = this.container.querySelector('.main-list-collections__image--primary');
      if (!primaryImage) return [];

      return [primaryImage.currentSrc, primaryImage.src, primaryImage.getAttribute('src')]
        .filter(Boolean)
        .map((src) => {
          try {
            return new URL(src, window.location.origin).href;
          } catch (error) {
            return src;
          }
        });
    }

    getHintImageData() {
      const primarySources = this.getPrimaryImageSourceCandidates();

      return this.images.find((imageData) => {
        try {
          const normalizedHintSrc = new URL(imageData.src, window.location.origin).href;
          return !primarySources.includes(normalizedHintSrc);
        } catch (error) {
          return !primarySources.includes(imageData.src);
        }
      });
    }

    createHoverLayer(layerClassName) {
      const image = document.createElement('img');
      image.className = `main-list-collections__image main-list-collections__image--hover-layer ${layerClassName}`;
      image.alt = '';
      image.decoding = 'async';
      this.container.appendChild(image);
      return image;
    }

    createTouchHintIndicators() {
      if (this.touchHintTrack || this.touchHintRing || this.touchHintDot) return;

      this.touchHintTrack = document.createElement('span');
      this.touchHintTrack.className = 'main-list-collections__touch-hint-track';
      this.touchHintTrack.setAttribute('aria-hidden', 'true');

      this.touchHintRing = document.createElement('span');
      this.touchHintRing.className = 'main-list-collections__touch-hint-ring';
      this.touchHintRing.setAttribute('aria-hidden', 'true');

      this.touchHintDot = document.createElement('span');
      this.touchHintDot.className = 'main-list-collections__touch-hint-dot';
      this.touchHintDot.setAttribute('aria-hidden', 'true');

      this.touchHintTrack.appendChild(this.touchHintRing);
      this.touchHintTrack.appendChild(this.touchHintDot);
      this.container.appendChild(this.touchHintTrack);
    }

    async ensureHoverLayersInitialized() {
      if (this.hasInitializedHoverLayers) return true;

      const imageData = this.images[0];
      const loaded = await this.preloadImage(imageData.src);
      if (!loaded) return false;

      this.activeLayer.src = imageData.src;
      this.activeLayer.alt = imageData.alt || '';
      this.activeLayer.classList.add('is-active');
      this.currentIndex = 0;
      this.hasInitializedHoverLayers = true;
      this.preloadUpcomingImages();
      return true;
    }

    async startSlideshowPlayback() {
      if (this.isTransitioning) return false;

      const hasInitialized = await this.ensureHoverLayersInitialized();
      if (!hasInitialized) return false;

      this.container.classList.add('is-hover-active');
      this.mobileFrameIndex = this.currentIndex + 1;

      if (this.images.length > 1 && !this.intervalId) {
        this.intervalId = window.setInterval(() => {
          this.showNextImage();
        }, this.displayDuration);
      }

      return true;
    }

    stopSlideshowPlayback() {
      this.container.classList.remove('is-hover-active');
      this.mobileFrameIndex = 0;

      if (this.intervalId) {
        window.clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    async handlePointerEnter(event) {
      if (event.pointerType === 'touch') return;
      await this.startSlideshowPlayback();
    }

    handlePointerLeave(event) {
      if (event.pointerType === 'touch') return;
      this.stopSlideshowPlayback();
    }

    handlePointerDown(event) {
      if (event.pointerType !== 'touch') return;

      this.cancelSwipeHint();

      this.swipePointerId = event.pointerId;
      this.swipeStartX = event.clientX;
      this.swipeStartY = event.clientY;
      this.hasSwipeTriggered = false;
    }

    handlePointerMove(event) {
      if (event.pointerType !== 'touch') return;
      if (this.swipePointerId !== event.pointerId || this.hasSwipeTriggered) return;

      const deltaX = event.clientX - this.swipeStartX;
      const deltaY = event.clientY - this.swipeStartY;
      const moveX = Math.abs(deltaX);
      const moveY = Math.abs(deltaY);

      if (moveX < this.swipeThreshold) return;
      if (moveX <= moveY * 1.25) return;

      this.hasSwipeTriggered = true;
      this.armSwipeClickSuppression();
      const direction = deltaX < 0 ? 1 : -1;
      void this.showMobileFrameStep(direction);
    }

    handlePointerUp(event) {
      if (event.pointerType !== 'touch') return;
      if (this.swipePointerId !== null && this.swipePointerId !== event.pointerId) return;

      this.swipePointerId = null;
      this.hasSwipeTriggered = false;
    }

    async showMobileFrameStep(direction) {
      if (this.isTransitioning || this.images.length === 0) return;

      if (this.intervalId) {
        window.clearInterval(this.intervalId);
        this.intervalId = null;
      }

      const totalFrameCount = this.images.length + 1;
      const nextFrameIndex = (this.mobileFrameIndex + direction + totalFrameCount) % totalFrameCount;
      const didShowFrame = await this.showMobileFrame(nextFrameIndex, {
        mode: 'swipe',
        direction,
      });

      if (didShowFrame) {
        this.mobileFrameIndex = nextFrameIndex;
      }
    }

    async showMobileFrame(frameIndex, options = {}) {
      if (frameIndex === 0) {
        return this.showPrimaryImage(options.direction || -1, options.mode || 'fade');
      }

      return this.showHoverImage(frameIndex - 1, options);
    }

    handleLinkClick(event) {
      if (!this.suppressClick) return;

      event.preventDefault();
      event.stopPropagation();
      this.clearSwipeClickSuppression();
    }

    armSwipeClickSuppression() {
      this.clearSwipeClickSuppression();
      this.suppressClick = true;
      this.suppressClickTimerId = window.setTimeout(() => {
        this.clearSwipeClickSuppression();
      }, 180);
    }

    clearSwipeClickSuppression() {
      this.suppressClick = false;

      if (this.suppressClickTimerId) {
        window.clearTimeout(this.suppressClickTimerId);
        this.suppressClickTimerId = null;
      }
    }

    async showHoverImage(nextIndex, options = {}) {
      if (nextIndex < 0 || nextIndex >= this.images.length) return false;

      const nextImage = this.images[nextIndex];
      const loaded = await this.preloadImage(nextImage.src);

      if (!loaded) {
        return false;
      }

      if (options.mode === 'swipe' && this.isTouchLayout() && this.mobileFrameIndex === 0) {
        return this.slideFromPrimaryToHoverImage(nextIndex, options.direction || 1);
      }

      if (!this.hasInitializedHoverLayers) {
        if (options.mode === 'swipe' && this.isTouchLayout()) {
          return this.slideFromPrimaryToHoverImage(nextIndex, options.direction || 1);
        }

        this.activeLayer.src = nextImage.src;
        this.activeLayer.alt = nextImage.alt || '';
        this.activeLayer.classList.add('is-active');
        this.currentIndex = nextIndex;
        this.hasInitializedHoverLayers = true;
        this.container.classList.add('is-hover-active');
        this.preloadUpcomingImages();
        return true;
      }

      if (this.currentIndex === nextIndex) {
        this.container.classList.add('is-hover-active');
        return true;
      }

      if (this.isTransitioning) {
        return false;
      }

      if (options.mode === 'swipe' && this.isTouchLayout()) {
        return this.slideToHoverImage(nextIndex, options.direction || 1);
      }

      return this.fadeToHoverImage(nextIndex);
    }

    slideFromPrimaryToHoverImage(nextIndex, direction) {
      if (this.isTransitioning) {
        return Promise.resolve(false);
      }

      const primaryImage = this.container.querySelector('.main-list-collections__image--primary');
      if (!primaryImage) {
        return this.fadeToHoverImage(nextIndex);
      }

      this.isTransitioning = true;
      const nextImage = this.images[nextIndex];
      const enteringOffset = direction > 0 ? '100%' : '-100%';
      const leavingOffset = direction > 0 ? '-100%' : '100%';

      this.activeLayer.src = nextImage.src;
      this.activeLayer.alt = nextImage.alt || '';
      this.activeLayer.classList.add('is-active');
      this.container.classList.add('is-hover-active', 'main-list-collections__media--swipe-transitioning');

      primaryImage.style.transition = 'none';
      primaryImage.style.transform = 'translate3d(0, 0, 0)';
      primaryImage.style.opacity = '1';
      this.activeLayer.style.transition = 'none';
      this.activeLayer.style.transform = `translate3d(${enteringOffset}, 0, 0)`;
      this.activeLayer.style.opacity = '1';

      return new Promise((resolve) => {
        window.requestAnimationFrame(() => {
          const slideTransition = `transform ${this.transitionDuration}ms ease, opacity ${this.transitionDuration}ms ease`;
          primaryImage.style.transition = slideTransition;
          this.activeLayer.style.transition = slideTransition;
          primaryImage.style.transform = `translate3d(${leavingOffset}, 0, 0)`;
          primaryImage.style.opacity = '0';
          this.activeLayer.style.transform = 'translate3d(0, 0, 0)';

          window.setTimeout(() => {
            this.container.classList.remove('main-list-collections__media--swipe-transitioning');
            primaryImage.style.transition = '';
            primaryImage.style.transform = '';
            primaryImage.style.opacity = '';
            this.activeLayer.style.transition = '';
            this.activeLayer.style.transform = '';
            this.activeLayer.style.opacity = '';
            this.currentIndex = nextIndex;
            this.mobileFrameIndex = nextIndex + 1;
            this.hasInitializedHoverLayers = true;
            this.preloadUpcomingImages();
            this.isTransitioning = false;
            resolve(true);
          }, this.transitionDuration);
        });
      });
    }

    fadeToHoverImage(nextIndex) {
      if (this.isTransitioning) {
        return Promise.resolve(false);
      }

      this.isTransitioning = true;
      const nextImage = this.images[nextIndex];
      this.inactiveLayer.src = nextImage.src;
      this.inactiveLayer.alt = nextImage.alt || '';
      this.container.classList.add('is-hover-active');

      return new Promise((resolve) => {
        window.requestAnimationFrame(() => {
          this.inactiveLayer.classList.add('is-active');
          this.activeLayer.classList.remove('is-active');

          const previousLayer = this.activeLayer;
          this.activeLayer = this.inactiveLayer;
          this.inactiveLayer = previousLayer;
          this.currentIndex = nextIndex;
          this.preloadUpcomingImages();

          window.setTimeout(() => {
            this.isTransitioning = false;
            resolve(true);
          }, this.transitionDuration);
        });
      });
    }

    slideToHoverImage(nextIndex, direction) {
      if (this.isTransitioning) {
        return Promise.resolve(false);
      }

      this.isTransitioning = true;
      const nextImage = this.images[nextIndex];
      const enteringOffset = direction > 0 ? '100%' : '-100%';
      const leavingOffset = direction > 0 ? '-100%' : '100%';

      this.inactiveLayer.src = nextImage.src;
      this.inactiveLayer.alt = nextImage.alt || '';
      this.container.classList.add('is-hover-active', 'main-list-collections__media--swipe-transitioning');

      this.activeLayer.style.transition = 'none';
      this.inactiveLayer.style.transition = 'none';
      this.inactiveLayer.style.opacity = '1';
      this.inactiveLayer.style.transform = `translate3d(${enteringOffset}, 0, 0)`;
      this.activeLayer.style.transform = 'translate3d(0, 0, 0)';

      return new Promise((resolve) => {
        window.requestAnimationFrame(() => {
          const slideTransition = `transform ${this.transitionDuration}ms ease, opacity ${this.transitionDuration}ms ease`;
          this.activeLayer.style.transition = slideTransition;
          this.inactiveLayer.style.transition = slideTransition;
          this.inactiveLayer.classList.add('is-active');
          this.activeLayer.classList.remove('is-active');
          this.inactiveLayer.style.transform = 'translate3d(0, 0, 0)';
          this.activeLayer.style.transform = `translate3d(${leavingOffset}, 0, 0)`;
          this.activeLayer.style.opacity = '0';

          const previousLayer = this.activeLayer;
          this.activeLayer = this.inactiveLayer;
          this.inactiveLayer = previousLayer;
          this.currentIndex = nextIndex;
          this.preloadUpcomingImages();

          window.setTimeout(() => {
            this.container.classList.remove('main-list-collections__media--swipe-transitioning');
            this.activeLayer.style.transition = '';
            this.activeLayer.style.transform = '';
            this.activeLayer.style.opacity = '';
            this.inactiveLayer.style.transition = '';
            this.inactiveLayer.style.transform = '';
            this.inactiveLayer.style.opacity = '';
            this.isTransitioning = false;
            resolve(true);
          }, this.transitionDuration);
        });
      });
    }

    showPrimaryImage(direction, mode) {
      if (!this.hasInitializedHoverLayers) {
        this.container.classList.remove('is-hover-active');
        this.mobileFrameIndex = 0;
        return Promise.resolve(true);
      }

      if (mode === 'swipe' && this.isTouchLayout()) {
        return this.slideToPrimaryImage(direction);
      }

      this.container.classList.remove('is-hover-active');
      this.mobileFrameIndex = 0;
      return Promise.resolve(true);
    }

    slideToPrimaryImage(direction) {
      if (this.isTransitioning) {
        return Promise.resolve(false);
      }

      this.isTransitioning = true;
      const enteringOffset = direction > 0 ? '100%' : '-100%';
      const leavingOffset = direction > 0 ? '-100%' : '100%';
      const primaryImage = this.container.querySelector('.main-list-collections__image--primary');

      if (!primaryImage) {
        this.container.classList.remove('is-hover-active');
        this.isTransitioning = false;
        return Promise.resolve(true);
      }

      this.container.classList.add('main-list-collections__media--swipe-transitioning', 'is-hover-active');
      primaryImage.style.transition = 'none';
      primaryImage.style.opacity = '1';
      primaryImage.style.transform = `translate3d(${enteringOffset}, 0, 0)`;
      this.activeLayer.style.transition = 'none';
      this.activeLayer.style.transform = 'translate3d(0, 0, 0)';
      this.activeLayer.style.opacity = '1';

      return new Promise((resolve) => {
        window.requestAnimationFrame(() => {
          const slideTransition = `transform ${this.transitionDuration}ms ease, opacity ${this.transitionDuration}ms ease`;
          primaryImage.style.transition = slideTransition;
          this.activeLayer.style.transition = slideTransition;
          primaryImage.style.transform = 'translate3d(0, 0, 0)';
          this.activeLayer.style.transform = `translate3d(${leavingOffset}, 0, 0)`;
          this.activeLayer.style.opacity = '0';
          this.container.classList.remove('is-hover-active');

          window.setTimeout(() => {
            this.container.classList.remove('main-list-collections__media--swipe-transitioning');
            primaryImage.style.transition = '';
            primaryImage.style.transform = '';
            primaryImage.style.opacity = '';
            this.inactiveLayer.style.transition = '';
            this.inactiveLayer.style.transform = '';
            this.inactiveLayer.style.opacity = '';
            this.activeLayer.style.transition = '';
            this.activeLayer.style.transform = '';
            this.activeLayer.style.opacity = '';
            this.mobileFrameIndex = 0;
            this.isTransitioning = false;
            resolve(true);
          }, this.transitionDuration);
        });
      });
    }

    async playSwipeHint() {
      if (!this.hasSwipeHint || this.isTransitioning || this.swipePointerId !== null || !this.shouldPlayHint()) return;

      this.isHintRunning = true;
      const hintImage = this.getHintImageData();
      if (!hintImage) {
        this.isHintRunning = false;
        return;
      }

      const loaded = await this.preloadImage(hintImage.src);

      if (!loaded || this.swipePointerId !== null) {
        this.isHintRunning = false;
        return;
      }

      const hintLayer = this.hintLayer;
      const hintTrack = this.touchHintTrack;
      hintLayer.src = hintImage.src;
      hintLayer.alt = hintImage.alt || '';

      const hintTransition = `transform ${this.transitionDuration}ms ease, opacity ${this.transitionDuration}ms ease`;
      this.container.classList.add('main-list-collections__media--swipe-hinting', 'main-list-collections__media--swipe-hinting-touch');
      hintLayer.style.transition = 'none';
      hintLayer.style.opacity = '1';
      hintLayer.style.transform = 'translate3d(100%, 0, 0)';

      if (hintTrack) {
        hintTrack.style.transition = 'none';
        hintTrack.style.transform = 'translate3d(100%, 0, 0)';
      }

      this.queueHintTimer(() => {
        if (this.swipePointerId !== null) {
          this.resetHintLayer();
          return;
        }

        hintLayer.style.transition = hintTransition;
        hintLayer.style.transform = 'translate3d(50%, 0, 0)';

        if (hintTrack) {
          hintTrack.style.transition = hintTransition;
          hintTrack.style.transform = 'translate3d(50%, 0, 0)';
        }

        this.queueHintTimer(() => {
          if (this.swipePointerId !== null) {
            this.resetHintLayer();
            return;
          }

          hintLayer.style.transform = 'translate3d(100%, 0, 0)';
          hintLayer.style.opacity = '0';

          if (hintTrack) {
            hintTrack.style.transform = 'translate3d(100%, 0, 0)';
            hintTrack.style.opacity = '0';
          }

          this.queueHintTimer(() => {
            this.resetHintLayer();
          }, this.transitionDuration + 34);
        }, this.hintAnimationDuration - this.transitionDuration);
      }, 60);
    }

    resetHintLayer() {
      this.clearHintTimers();
      this.container.classList.remove('main-list-collections__media--swipe-hinting', 'main-list-collections__media--swipe-hinting-touch');
      this.hintLayer.style.transition = '';
      this.hintLayer.style.transform = '';
      this.hintLayer.style.opacity = '';

      if (this.touchHintTrack) {
        this.touchHintTrack.style.transition = '';
        this.touchHintTrack.style.transform = '';
        this.touchHintTrack.style.opacity = '';
      }

      this.queueHintTimer(() => {
        if (this.isHintRunning) return;

        this.hintLayer.src = '';
        this.hintLayer.alt = '';
      }, 34);

      this.isHintRunning = false;
    }

    async showNextImage() {
      if (this.images.length < 2) return;

      const nextIndex = (this.currentIndex + 1) % this.images.length;
      const didShowNextImage = await this.showHoverImage(nextIndex);

      if (didShowNextImage) {
        this.mobileFrameIndex = this.currentIndex + 1;
      }
    }

    preloadUpcomingImages() {
      if (this.images.length < 2) return;

      const nextIndex = (this.currentIndex + 1) % this.images.length;
      this.preloadImage(this.images[nextIndex].src);

      const afterNextIndex = (nextIndex + 1) % this.images.length;
      if (afterNextIndex !== nextIndex) {
        this.preloadImage(this.images[afterNextIndex].src);
      }
    }

    preloadImage(src) {
      if (this.preloadPromises.has(src)) {
        return this.preloadPromises.get(src);
      }

      const preloadPromise = new Promise((resolve) => {
        const image = new Image();
        image.onload = () => resolve(true);
        image.onerror = () => resolve(false);
        image.src = src;
      });

      this.preloadPromises.set(src, preloadPromise);
      return preloadPromise;
    }
  }

  const initMainListCollectionsMediaSkeletons = (root = document) => {
    root.querySelectorAll('.main-list-collections__media:not([data-media-load-initialized])').forEach((media) => {
      media.dataset.mediaLoadInitialized = 'true';

      const primaryImage = media.querySelector('.main-list-collections__image--primary');
      if (!primaryImage) {
        media.classList.add('is-media-loaded');
        return;
      }

      const markMediaLoaded = () => {
        media.classList.add('is-media-loaded');
      };

      if (primaryImage.complete && primaryImage.naturalWidth > 0) {
        markMediaLoaded();
        return;
      }

      primaryImage.addEventListener('load', markMediaLoaded, { once: true });
      primaryImage.addEventListener('error', markMediaLoaded, { once: true });
    });
  };

  const initMainListCollectionsHoverSlideshows = (root = document) => {
    root.querySelectorAll('.main-list-collections__media--hover-slideshow:not([data-hover-slideshow-initialized])').forEach((container) => {
      container.dataset.hoverSlideshowInitialized = 'true';
      new MainListCollectionsHoverSlideshow(container);
    });
  };

  initMainListCollectionsMediaSkeletons();
  initMainListCollectionsHoverSlideshows();

  document.addEventListener('shopify:section:load', (event) => {
    initMainListCollectionsMediaSkeletons(event.target);
    initMainListCollectionsHoverSlideshows(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
